<template>
    <div id="alertes" class="relative">
        <button id="toggle-alerts" @click="toggleNotifs" type="button" class="relative z-50 focus:outline-none"
            aria-label="Voir les notifications">
            <i class="inline-block h-8 w-8 mask mask-cloche bg-white"></i>
            <span
                class="absolute -top-1 -right-1 w-5 h-5 bg-orange text-white text-xs flex items-center justify-center rounded-full font-bold">{{
                    nbNotifs }}</span>
        </button>

        <div id="notif-popover" v-show="isOpen && nbNotifs > 0"
            class="fixed top-16 left-1/2 -translate-x-1/2 w-[90vw] sm:w-96 bg-white text-black rounded-xl shadow-lg z-50 overflow-x-hidden overflow-y-auto max-h-[75vh] border-2 border-secondary">
            <ul class="list-alertes divide-y divide-gray-200 px-4">

                <!-- WARNINGS OUTILS -->
                <li v-for="notif in orderBy(warningsOutil, 'diff', 'desc')" :key="notif.id"
                    class="flex items-start gap-4 py-3 min-w-0 -mx-4 px-4"
                    style="background-color: rgba(194, 221, 255, 0.4);">

                    <i class="shrink-0 inline-block h-6 w-6 mask mt-1" :class="[
                        'mask-' + notif.type_notif,
                        notif.type_notif === 'error' ? 'bg-error' : '',
                        notif.type_notif === 'warning' ? 'bg-warning' : ''
                    ]"></i>

                    <div class="flex flex-col gap-1 min-w-0 flex-1 break-words">
                        <p :class="[
                            notif.type_notif === 'error' ? 'text-error' : '',
                            notif.type_notif === 'warning' ? 'text-warning' : ''
                        ]">
                            Expire le <strong>{{ notif.date_butoir | dateFormat }}</strong>
                        </p>

                        <p>
                            {{ notif.type_outil.nom }}
                            <strong>{{ notif.modele }} {{ notif.marque }}</strong>
                        </p>
                    </div>

                </li>

                <!-- ERREURS OUTILS -->
                <li v-for="notif in errorsOutil" :key="notif.id" class="flex items-start gap-4 py-3 min-w-0 -mx-4 px-4"
                    style="background-color: rgba(194, 221, 255, 0.4);">

                    <i class="shrink-0 inline-block h-6 w-6 mask mt-1" :class="[
                        'mask-' + notif.type_notif,
                        notif.type_notif === 'error' ? 'bg-error' : '',
                        notif.type_notif === 'warning' ? 'bg-warning' : ''
                    ]"></i>

                    <div class="flex flex-col gap-1 min-w-0 flex-1 break-words">
                        <p :class="[
                            notif.type_notif === 'error' ? 'text-error' : '',
                            notif.type_notif === 'warning' ? 'text-warning' : ''
                        ]">
                            Expiré le <strong>{{ notif.date_butoir | dateFormat }}</strong>
                        </p>

                        <p>
                            {{ notif.type_outil.nom }}
                            <strong>{{ notif.modele }} {{ notif.marque }}</strong>
                        </p>
                    </div>

                </li>

                <!-- ERREURS BOUTEILLES -->
                <li v-for="notif in orderBy(errorsBouteille, 'diff', 'desc')" :key="notif.id"
                    class="flex items-start gap-4 py-3 min-w-0 -mx-4 px-4"
                    style="background-color: rgba(231, 237, 247, 0.4);">

                    <i class="shrink-0 inline-block h-6 w-6 mask mt-1" :class="[
                        'mask-' + notif.type_notif,
                        notif.type_notif === 'error' ? 'bg-error' : '',
                        notif.type_notif === 'warning' ? 'bg-warning' : ''
                    ]"></i>

                    <div class="flex flex-col gap-1 min-w-0 flex-1 break-words">
                        <p :class="[
                            notif.type_notif === 'error' ? 'text-error' : '',
                            notif.type_notif === 'warning' ? 'text-warning' : ''
                        ]">
                            Retard retour de <strong>{{ Math.floor(notif.diff) }} jour(s)</strong>
                        </p>

                        <p>
                            Bouteille {{ notif.type }} <strong>{{ notif.code }}</strong>
                        </p>
                    </div>

                </li>

                <!-- WARNINGS BOUTEILLES -->
                <li v-for="notif in orderBy(warningsBouteille, 'diff', 'desc')" :key="notif.id"
                    class="flex items-start gap-4 py-3 min-w-0 -mx-4 px-4"
                    style="background-color: rgba(231, 237, 247, 0.4);">

                    <i class="shrink-0 inline-block h-6 w-6 mask mt-1" :class="[
                        'mask-' + notif.type_notif,
                        notif.type_notif === 'error' ? 'bg-error' : '',
                        notif.type_notif === 'warning' ? 'bg-warning' : ''
                    ]"></i>

                    <div class="flex flex-col gap-1 min-w-0 flex-1 break-words">
                        <p :class="[
                            notif.type_notif === 'error' ? 'text-error' : '',
                            notif.type_notif === 'warning' ? 'text-warning' : ''
                        ]">
                            Retour dans <strong>{{ Math.abs(Math.floor(notif.diff)) }} jour(s)</strong>
                        </p>

                        <p>
                            Bouteille {{ notif.type }} <strong>{{ notif.code }}</strong>
                        </p>
                    </div>

                </li>

            </ul>




        </div>
    </div>

</template>

<script>

import Bouteille from '../../js/models/Bouteille'
import Outil from '../../js/models/Outil'

export default {

    data() {
        return {
            errorsOutil: [],
            warningsOutil: [],
            errorsBouteille: [],
            warningsBouteille: [],
            isOpen: false,
        }
    },

    methods: {
        orderBy(type, param, sens) {
            return _.orderBy(type, param, sens)
        },

        toggleNotifs() {
            if (this.nbNotifs === 0) return;
            this.isOpen = !this.isOpen;
        },

        fetchNotifs() {
            Bouteille
                .getWarningsBouteille()
                .then(data => this.warningsBouteille = data)
                .catch();

            Bouteille
                .getErrorsBouteille()
                .then(data => this.errorsBouteille = data)
                .catch();

            Outil
                .getWarningOutils()
                .then(data => this.warningsOutil = data)
                .catch();

            Outil
                .getErrorsOutils()
                .then(data => this.errorsOutil = data)
                .catch();
        }
    },

    computed: {

        nbNotifs: function () {
            let total = 0;

            if (this.warningsOutil !== null) {
                total += this.warningsOutil.length
            }
            if (this.errorsOutil !== null) {
                total += this.errorsOutil.length
            }
            if (this.warningsBouteille !== null) {
                total += this.warningsBouteille.length
            }
            if (this.errorsBouteille !== null) {
                total += this.errorsBouteille.length
            }

            return total
        },

    },

    mounted: function () {

        this.fetchNotifs()

    }
}

</script>



// WEBPACK FOOTER //
// NotifBar.vue?570a1f4f